module.exports = __webpack_public_path__ + "static/nord-banner-56b50306662daed66109a66aec61d2ec.png";